/* Predictive search — fetches /search/suggest.json, keyboard navigable */
(function () {
  'use strict';

  var DEBOUNCE_MS = 220;

  /* Escape HTML in strings injected via innerHTML (defense against stored XSS via product/vendor titles) */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function init() {
    var wrappers = document.querySelectorAll('[data-predictive-search]');
    if (!wrappers.length) return;
    wrappers.forEach(setup);
  }

  function setup(wrapper) {
    var form = wrapper.querySelector('[data-predictive-form]');
    var input = wrapper.querySelector('[data-predictive-input]');
    var panel = wrapper.querySelector('[data-predictive-results]');
    var inner = wrapper.querySelector('[data-predictive-inner]');
    var viewAll = wrapper.querySelector('[data-predictive-viewall]');
    var status = wrapper.querySelector('[data-predictive-status]');
    if (!form || !input || !panel || !inner) return;

    var timer = null;
    var activeIndex = -1;
    var options = [];

    function open() {
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function close() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
    }

    function setActive(i) {
      options.forEach(function (opt, idx) {
        opt.classList.toggle('is-active', idx === i);
        opt.setAttribute('aria-selected', idx === i ? 'true' : 'false');
      });
      activeIndex = i;
      if (options[i]) {
        input.setAttribute('aria-activedescendant', options[i].id);
        options[i].scrollIntoView({ block: 'nearest' });
      } else {
        input.removeAttribute('aria-activedescendant');
      }
    }

    function money(cents) {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: 'USD' });
    }

    function render(data, query) {
      var html = '';
      var groups = [
        { key: 'products', label: input.getAttribute('data-label-products') },
        { key: 'collections', label: input.getAttribute('data-label-collections') },
        { key: 'pages', label: input.getAttribute('data-label-pages') }
      ];

      groups.forEach(function (g) {
        var items = (data.resources && data.resources.results && data.resources.results[g.key]) || [];
        if (!items.length) return;
        html += '<p class="predictive-search__group-label">' + g.label + '</p>';
        items.forEach(function (item) {
          if (g.key === 'products') {
            var img = item.image ? '<img class="predictive-search__thumb" src="' + esc(item.image) + '" alt="" loading="lazy">' : '';
            var price = item.price ? '<span class="predictive-search__price">' + esc(item.price) + '</span>' : '';
            html += '<a class="predictive-search__item" role="option" href="' + esc(item.url) + '">' +
              img +
              '<span><span class="predictive-search__title">' + esc(item.title) + '</span>' +
              (item.vendor ? '<br><span class="predictive-search__meta">' + esc(item.vendor) + '</span>' : '') +
              '</span>' + price + '</a>';
          } else {
            html += '<a class="predictive-search__item" role="option" href="' + esc(item.url) + '">' +
              '<span class="predictive-search__thumb predictive-search__thumb--icon"></span>' +
              '<span class="predictive-search__title">' + esc(item.title) + '</span></a>';
          }
        });
      });

      if (!html) {
        html = '<p class="predictive-search__none">' + input.getAttribute('data-label-none') + '</p>';
        if (viewAll) viewAll.hidden = true;
      } else if (viewAll) {
        viewAll.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'search?q=' + encodeURIComponent(query);
        viewAll.hidden = false;
      }

      inner.innerHTML = html;
      options = Array.prototype.slice.call(inner.querySelectorAll('[role="option"]'));
      options.forEach(function (opt, i) {
        opt.id = 'ps-option-' + i + '-' + Math.floor(Math.random() * 1e6);
        opt.setAttribute('aria-selected', 'false');
      });
      setActive(-1);
      open();
      if (status) status.textContent = options.length + ' ' + input.getAttribute('data-label-results');
    }

    function search(query) {
      if (query.length < 2) { close(); return; }
      inner.innerHTML = '<p class="predictive-search__loading">' + input.getAttribute('data-label-loading') + '</p>';
      open();
      var url = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'search/suggest.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product,collection,page&resources[limit]=5&resources[options][unavailable_products]=hide';
      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (data) { render(data, query); })
        .catch(function () { close(); });
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      timer = setTimeout(function () { search(q); }, DEBOUNCE_MS);
    });

    input.addEventListener('focus', function () {
      var q = input.value.trim();
      if (q.length >= 2 && inner.innerHTML) open();
    });

    input.addEventListener('keydown', function (e) {
      if (panel.hidden) return;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        setActive((activeIndex + 1) % Math.max(options.length, 1));
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        setActive((activeIndex - 1 + options.length) % Math.max(options.length, 1));
      } else if (e.key === 'Enter' && activeIndex >= 0 && options[activeIndex]) {
        e.preventDefault();
        window.location.href = options[activeIndex].getAttribute('href');
      } else if (e.key === 'Escape') {
        close();
        input.blur();
      }
    });

    document.addEventListener('click', function (e) {
      if (!wrapper.contains(e.target)) close();
    });
  }

  document.addEventListener('DOMContentLoaded', init);
})();
